import React from "react";
import { ReactComponent as SmtpIcon } from "Assets/svg/bulkCsvConnect/smtp.svg";
import { ReactComponent as CloseIcon } from "Assets/svg/bjnClose.svg";

const BulkCsvModal = (props = {}) => {
  const {
    title = "",
    subtitle = "",
    onClose = () => {},
    children,
    footer,
    wide = false
  } = props || {};

  return (
    <div className="popupWrapper bulkCsvConnectWrapper">
      <div className="bulkCsvConnectMask" onClick={onClose} />
      <div className={`bulkCsvConnectPopup ${wide ? "wide" : ""}`}>
        <div className="bulkCsvConnectHeader">
          <div className="headerLeft">
            <div className="headerIcon">
              <SmtpIcon />
            </div>
            <div className="headerText">
              <p className="title">{title}</p>
              {subtitle && <p className="subtitle">{subtitle}</p>}
            </div>
          </div>
          <button
            type="button"
            className="closeBtn"
            id="closeBulkCsvConnect"
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        </div>
        <div className="bulkCsvConnectBody">{children}</div>
        {footer && <div className="bulkCsvConnectFooter">{footer}</div>}
      </div>
    </div>
  );
};

export default BulkCsvModal;
export { BulkCsvModal };
